/**
 * PilotHintArrowContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled pilot hint arrow container.
 */
const PilotHintArrowContainer = styled.div`
  margin: 0 ${Screen.widthRatio * 16}px;
`;

export default PilotHintArrowContainer;
